import { action } from 'satcheljs/lib/legacy';
import MeetingMessage from 'owa-service/lib/contract/MeetingMessage';

export const DeleteMeetingMessageActionName = 'deleteMeetingMessage';

export type DeleteMeetingMessageAction = (
    item: MeetingMessage,
    issueDeleteItemCall?: boolean
) => void;

export default action(DeleteMeetingMessageActionName)(function deleteMeetingMessage(
    item: MeetingMessage,
    issueDeleteItemCall?: boolean
) {
    // No-op. Action is performed by stitch listening in reading pane
});
